import { PackageFormFields } from '../static/react-injector/src/injectables/modules/Components/PackageAddEditForm';

// api to be shared between DE and ReactInjector
declare global {
    interface Window {
        de: DE;
    }

    interface DE {
        navigate: DE_Navigation;
    }

    interface DE_Navigation {
        createFunctionComponent: (params: Partial<PackageFormFields>, newTab?: boolean) => void;

        navigateWithStoredParams: <T>(
            urlHash: string,
            params: T,
            storageKey: string,
            newTab?: false,
        ) => void;
        getStoredParams: <T>(storageKey: string, key?: string, remove?: boolean) => T | undefined;
        popStoredParams: <T>(storageKey: string, key?: string) => T | undefined;
    }
}

window.de = {
    navigate: {} as DE_Navigation,
} as DE;
